import React from "react";
// icons
import { IconShoppingBag, IconUser } from "@tabler/icons-react";
// component
import CreatePlans from "../../pages/admin/plans/createPlans.tsx";
import PlansList from "../../pages/admin/plans/plansList.tsx";
import UserAgent from "../../pages/admin/user/child/agent.tsx";
import UserPhotographer from "../../pages/admin/user/child/photographer.tsx";
import CreateUpdateAgent from "../../pages/admin/user/child/createUpdateAgent.tsx";
import CreateUpdatePhotographer from "../../pages/admin/user/child/createUpdatePhotographer.tsx";

export const AdminRoutes: any = {
    admin: [
        {
            label: 'کاربران',
            address: '/dashboard/admin/user/agent',
            component: <UserAgent />,
            icon: <IconUser
                size={20}
                className="ms-2 admin-menu-item-svg vertical-td" />
            ,
            items: [
                {
                    label: 'مشاورین املاک',
                    address: '/dashboard/admin/user/agent',
                    component: <UserAgent />,
                    show: true,
                },
                {
                    label: 'ایجاد مشاور',
                    address: '/dashboard/admin/user/agent/create',
                    component: <CreateUpdateAgent />,
                    show: false,
                },
                {
                    label: 'اپدیت مشاور',
                    address: '/dashboard/admin/user/agent/update/:id',
                    component: <CreateUpdateAgent />,
                    show: false,
                },
                {
                    label: 'عکاسان',
                    address: '/dashboard/admin/admin/user/photographer',
                    component: <UserPhotographer />,
                    show: true,
                },
                {
                    label: 'ایجاد عکاس',
                    address: '/dashboard/admin/user/photographer/create',
                    component: <CreateUpdatePhotographer />,
                    show: false,
                },
                {
                    label: 'اپدیت عکاس',
                    address: '/dashboard/admin/user/photographer/update/:id',
                    component: <CreateUpdatePhotographer />,
                    show: false,
                },
            ]
        },
        {
            label: 'پلن ها',
            address: '/dashboard/admin/plans',
            component: <PlansList />,
            icon: <IconShoppingBag
                size={20}
                className="ms-2 admin-menu-item-svg vertical-td" />
            ,
            items: [
                {
                    label: 'لیست پلن ها',
                    address: '/dashboard/admin/plans',
                    show: true,
                },
                {
                    label: 'ایجاد پلن',
                    address: '/dashboard/admin/plans/create',
                    component: <CreatePlans />,
                    show: true,
                },
                {
                    label: 'ادیت پلن',
                    address: '/dashboard/admin/plans/update/:id',
                    component: <CreatePlans />,
                    show: false,
                },
            ]
        },
    ],
}
